import React from 'react';
import InfoCardDossier from '../../InfoCardDossier/InfoCardDossier';
import EditablePriorityChip from '../../EditablePriorityChip/EditablePriorityChip';
import { PriorityCardProps } from './types';

const PriorityCard: React.FunctionComponent<PriorityCardProps> = function ({
    critical,
    onPriorityChange,
    isUpdatingPriority,
    infoCardSx,
}) {
    return (
        <InfoCardDossier
            label="Priorité "
            sx={infoCardSx}
        >
            <EditablePriorityChip
                critical={critical}
                onPriorityChange={onPriorityChange}
                isLoading={isUpdatingPriority}
                fontSx={{ fontSize: '13px' }}
            />
        </InfoCardDossier>
    );
};

export default PriorityCard;
